import { ThemeOptions } from '@mui/material';
import { getListItemStyles } from './MuiListItem';
import { getListItemInteractiveStyles } from './MuiListItemButton';

export const MuiMenuItem: ThemeOptions['components']['MuiMenuItem'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      ...getListItemStyles(theme),
      ...getListItemInteractiveStyles(theme)
    })
  }
};
